import { create } from "zustand";

interface ThemeStore {
  isDarkTheme: boolean;
  toggleDarkTheme: () => void;
}

// Global (not per-header) so the choice survives navigating between the
// analytics app (AuthHeader) and the builder (BuilderHeader) — each has its
// own toggle button, but they read/write the same state rather than each
// header resetting to light on mount.
const useThemeStore = create<ThemeStore>((set) => ({
  isDarkTheme: false,
  toggleDarkTheme: () => set((state) => ({ isDarkTheme: !state.isDarkTheme })),
}));

export default useThemeStore;
